import { configuration } from "@faire/web--source/common/settings/declarations/configuration";

export const FE_ENABLE_HOMEPAGE_PREFETCHING_250204 =
  configuration({
    name: "FE_ENABLE_HOMEPAGE_PREFETCHING_250204",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    defaultValue: false,
    productArea: "HOME_FEED",
  });
